import { MyModal } from '~/components/ui/MyModal'

export enum MUTE_SCENE {
  COMPETITION = 'COMPETITION',
  SQUARE = 'SQUARE',
  COMMENT = 'COMMENT',
}
const MUTE_SCENE_CN = {
  COMPETITION: '进行投稿',
  SQUARE: '发布词/图',
  COMMENT: '评论',
}

export const useMute = () => {
  const showMute = (endTime?: string | null, scene?: MUTE_SCENE) => {
    MyModal.info({
      centered: true,
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: 'hookModal dark',
      content: (
        <div className="text-sm text-left text-neutral-800">
          {endTime === '永久' ? (
            <span>
              抱歉，您被永久禁言，无法
              {MUTE_SCENE_CN[scene || MUTE_SCENE.COMPETITION]}。
            </span>
          ) : (
            <>
              抱歉，您还在禁言期间，无法
              {MUTE_SCENE_CN[scene || MUTE_SCENE.COMPETITION]}
              {scene !== MUTE_SCENE.COMMENT && '，请在禁言结束后参与活动'}。
              <div className="flex items-center justify-center text-error bg-error bg-opacity-20 rounded-[12px] mt-2">
                剩余禁言时间：{endTime}
              </div>
            </>
          )}
        </div>
      ),
      okText: '知道了',
      onOk: close => {
        close()
      },
    })
  }
  return { showMute }
}
